export default {
  Browser: 'Browser',
  Hash: 'Hash'
};
